// 数据中心

$('#quoteSearchBtn').on('click', function(){
  //@ts-ignore
  searchData()
})

$('#searchForm').on('submit',function(){
  return false
})

// $('#priceO_val').on('keyup',function(e){
//   //@ts-ignore
//   checkNo(e,document.getElementById('priceO_val'))
// })

// $('#priceT_val').on('keyup',function(e){
//   //@ts-ignore
//   checkNo(e,document.getElementById('priceT_val'))
// })


// 截止日期
$('#endDate').on('click',function(){
  
  //@ts-ignore
  WdatePicker({ onpicked: function (dp) { dealDateChange() },el:document.getElementById('endDate')})
})

// 开始日期
$('#startDate').on('click',function(){
  
  //@ts-ignore
  WdatePicker({ onpicked: function (dp) { dealDateChange() },el:document.getElementById('startDate')})
})
